import orderMaster from './orderMaster';
import wx from '../../../api/wx';

export default {
    install(Vue) {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$api = {
            orderMaster,
            wx,
        };
    },
};
